module.exports = __webpack_public_path__ + "img/Centre_national_de_la_recherche_scientifique.2cadb3ec.jpg";